import { AiOutlineAlert } from "react-icons/ai";
import { NotificationCategory, NotificationCategoryNames, NotificationSource } from "../../constants/notifications.constants";
import { isCategoryAlert, useNotifications } from "../../contexts/notifications";
import { formatWeekDayAndHour } from "../../utils/date";
import { InvitationButtons } from "../../views/EditProfile/Invites/InvitationButtons";
import Image from "../Image/Image";
import { TimeAgo } from "../TimeAgo/TimeAgo";
import "./NotificationCard.css";
import { LuCpu, LuDatabaseBackup } from "react-icons/lu";
import { PiFlowArrowBold } from "react-icons/pi";
import { MdPerson } from "react-icons/md";
import { BsDatabaseAdd, BsDatabaseCheck } from "react-icons/bs";
import { AlarmActions } from "../AlarmActions/AlarmActions";

export function getNotificationTitle({ notification }) {
	const metadata = notification.metadata;
	let title = notification.title;
	if (metadata && Number(notification.categoryId) === NotificationCategory.NewInvitation) {
		return (
			<span>
				<b>{metadata.from.name}</b> enviou um convite para você participar em <b>{metadata.organization.name}/{metadata.unit.name}</b>
			</span>
		);
	}
	if (notification.metadata?.name_code === 27) {
		title = 'Automação: ' + title;
	}
	return title;
}

export function getNotificationAvatar({ notification }) {
	if (notification?.metadata?.from) {
		return (
			<Image
				imgId={notification.metadata.from.urlAvatar}
				name={notification.metadata.from.name}
				alt="profile"
				isProfile
				className="header-bar-avatar"
			/>
		);
	}
	if (NotificationCategoryNames[Number(notification.categoryId)].toLowerCase().includes('alarm')) {
		return (
			<AiOutlineAlert size={32} />
		);
	}
	if (Number(notification.categoryId) === NotificationCategory.BackupUploaded) {
		return (
			<BsDatabaseAdd size={22} />
		);
	}
	if (Number(notification.categoryId) === NotificationCategory.BackupImported) {
		return (
			<BsDatabaseCheck size={22} />
		);
	}
	if (Number(notification.sourceId) === NotificationSource.Backups) {
		return (
			<LuDatabaseBackup size={20} />
		);
	}
	if (Number(notification.sourceId) === NotificationSource.AccessControl) {
		return (
			<PiFlowArrowBold size={20} />
		);
	}
	if (Number(notification.sourceId) === NotificationSource.ModuleEvents) {
		return (
			<LuCpu size={20} />
		);
	}
	if (Number(notification.sourceId) === NotificationSource.IdentityMdPerson) {
		return (
			<MdPerson size={20} />
		);
	}
}

export const NotificationCard = ({ notification }) => {
	const { deleteTarget, readTarget } = useNotifications()

	function getNotificationContent(target) {
		const metadata = target.notification.metadata;
		if (metadata && Number(target.notification.categoryId) === NotificationCategory.NewInvitation) {
			return (
				<InvitationButtons
					className="sm"
					showText={true}
					invitationId={metadata.id}
					onSubmit={async () => {
						deleteTarget(target.id);
					}}
				/>
			);
		}
		if (isCategoryAlert(target?.notification)) {
			return (
				<AlarmActions alarm={notification.notification.metadata} />
			);
		}
		return null;
	}

	async function onCardClick(event) {
		if (notification.readAt) return;
		readTarget(notification.externalId)
	}

	const content = getNotificationContent(notification);
	const hasContent = (content !== null || notification.notification.message !== null);

	return (
		<div className={`notification-card ${isCategoryAlert(notification?.notification) ? 'alert' : ''}`} onClick={onCardClick} data-content={hasContent}>
			<div className="avatar">
				{getNotificationAvatar(notification)}
			</div>
			<div className="content">
				<h3>
					<span>{getNotificationTitle(notification)}</span>
					{notification.readAt === null && (
						<span className="unseen-badge"></span>
					)}
				</h3>
				<div className="notification-time">
					<span>
						{formatWeekDayAndHour(notification.deliveredAt)}
						{notification.notification?.metadata?.unit && (
							<span style={{ paddingLeft: '4px' }}>• {`${notification.notification?.metadata?.unit.name} ${notification.notification?.metadata?.target_name ? '- ' + notification.notification?.metadata?.target_name : ''}`}</span>
						)}
					</span>
					<span><TimeAgo date={notification.deliveredAt} /></span>
				</div>
				{hasContent && (
					<div>
						{content}
						<p className="message">
							{notification.notification.message}
						</p>
					</div>
				)}
			</div>
		</div>
	);
}